import { CheckIcon as PhosphorCheckIcon } from "@phosphor-icons/react/dist/ssr/Check";

import { createAppIcon } from "@/components/createAppIcon";

export const CheckIcon = /* @__PURE__ */ createAppIcon(PhosphorCheckIcon);
